// extracted by mini-css-extract-plugin
export default {"container":"ModalFoodHolder_container__M8oYN","detail":"ModalFoodHolder_detail__2NE5F","control":"ModalFoodHolder_control__BkzRr","btn":"ModalFoodHolder_btn__+sPfQ"};